import { IScene } from "./IScene";

export type SceneConstructor<T = any> = new (canvas: HTMLCanvasElement) => IScene<T>
export class SceneFactory {
    private static _ctor: SceneConstructor;

    public static Register(ctor: SceneConstructor) {
        SceneFactory._ctor = ctor;
    }

    public static Create<T>(canvas: HTMLCanvasElement): IScene<T> {
        return new SceneFactory._ctor(canvas);
    }
}